import { render } from "./ticketdetail.vue?vue&type=template&id=1dd5c7e4"
import script from "./ticketdetail.vue?vue&type=script&lang=js"
export * from "./ticketdetail.vue?vue&type=script&lang=js"

import "./ticketdetail.vue?vue&type=style&index=0&id=1dd5c7e4&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__